import {
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme,
} from '@mui/material';

export default function ProfileMedicationsTableSkeleton() {
  const theme = useTheme();

  // One cell per column in ProfileMedicationsTable — the two must stay in step,
  // or the table visibly jumps as the rows arrive.
  const BODY_CELL_WIDTHS = [
    '120px',
    '100px',
    '60px',
    '140px',
    '80px',
    '90px',
    '70px',
  ];

  const BodyRow = (
    <TableRow>
      {BODY_CELL_WIDTHS.map((width, index) => (
        <TableCell align="left" key={`body-${index}`}>
          <Skeleton variant="rounded" height="22px" width={width} />
        </TableCell>
      ))}
    </TableRow>
  );

  return (
    <>
      <TableContainer
        sx={{ height: 1, display: 'flex', flexDirection: 'column' }}
      >
        <Table>
          <TableHead>
            <TableRow>
              {['60px', '70px', '70px', '90px', '60px', '60px', '60px'].map(
                (width, index) => (
                  <TableCell
                    align="left"
                    key={`head-${index}`}
                    sx={{ backgroundColor: theme.palette.grey[300] }}
                  >
                    <Skeleton variant="rounded" height="24px" width={width} />
                  </TableCell>
                ),
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
            {BodyRow}
          </TableBody>
        </Table>
      </TableContainer>
      <Skeleton variant="rectangular" height="1px" width="100%" />
      <Stack
        sx={{
          minHeight: 52,
          pr: 1,
          flexDirection: 'row',
          gap: 3,
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
      >
        <Skeleton variant="rounded" height="22px" width="170px" />
        <Skeleton variant="rounded" height="22px" width="50px" />
        <Stack sx={{ gap: 1, flexDirection: 'row' }}>
          <Skeleton variant="circular" height="40px" width="40px" />
          <Skeleton variant="circular" height="40px" width="40px" />
        </Stack>
      </Stack>
    </>
  );
}
